module.exports = __webpack_public_path__ + "static/img/icon_playing.6bf00be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_playing.png
// module id = 594
// module chunks = 1 7